const se = {
    common: {
        history: "historisk version"
    }
};
export default se;



// WEBPACK FOOTER //
// ./src/i18n/langs/se.js